import ButtonAction from '../../../components/buttons/ButtonAction';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import { AddIcon, EditIcon, TrashOutlineIcon } from '../../../components/buttons/IconButtons';
import HeadTittle from '../../../components/HeadTittle';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';
import { ACTION_MODEL } from '../../../Helpers/ActionModel';
import { permissionObj } from "../../../Helpers/permission";
import routes from "../../../Routes/routes";
import Cafeterias from "./Cafeteria/Cafeterias";
import FoodieMainApp from './Functionality/FoodieMainApp';
import Ingredients from './Ingredients/Ingredients';
import Menu from './Menu/Menu';
import {
    getOptions,
    SUB_VIEW_MODEL,
    TAB_PERMISSION_FOODIE,
    TABS_FOODIE
} from './Model/Models';
import Schedule from './Schedules/Schedule';
import Manage from './Manage/Manage';
import Dishes from './Dishes/Dishes';
import SearchFilterBtn from '../../../components/buttons/SearchFilterBtn';
import SearchFor from '../../Modals/SearchFor';
import Request from './Request/Request';
import {ATTENDANCE_MODES} from "./Manage/Models/Model";
import React from "react";
import ModuleExportDataBtn from "../../../components/ModuleExportDataButton/ModuleExportDataBtn";
import {ExportModuleData} from "../../../reduxToolkit/Files/FilesApi";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const FoodieMain = () => {
    const {
        t,
        DEV,
        permission,
        navigate,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        view,
        setView,
        moduleId,
        setModuleId,
        option,
        setOption,
        activeStep,
        setActiveStep,
        steps,
        criteria,
        setCriteria,
        bodyForExport,
        setBodyForExport,
        subView,
        setSubView,
        subViewChild,
        setSubViewChild,
        handleStepChange,
        handleCreateDelete,
        handleUpdate,
        paramsContext,
        permissionButtons,
        finalArray,
        setFinalArray,
        setFilterDialogShow,
        filterDialogShow,
        modified,
        setModified,
        simpleSearch,
        setSimpleSearch,
        render, setRender,
        selectedOption,
        setSelectedOption,
        isPilgrimsValidation,
        exportModuleDataOption,
        setExportModuleDataOption,
        handleDownloadExcelAttendance,
        handleDownloadPDFAttendance
    } = FoodieMainApp();

    if (
        !DEV &&
        !permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_CAFETERIA_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_MENU_READ) &&
        !permission?.includes(permissionObj?.WEB_INGREDIENT_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_ITEM_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_ATTENDANCE_READ) &&
        !permission?.includes(permissionObj?.WEB_TOTAL_MEALS_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_MEAL_FORECAST_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_ACCESS_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_REQUEST_READ) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_READ)
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={'dining_management'}>
                { isPilgrimsValidation &&
                    <ModuleExportDataBtn
                        id='btn_fm_module_export'
                        title={t("export_module_data", { module: exportModuleDataOption ? t(exportModuleDataOption?.toUpperCase()): ''})}
                        endPoint={ExportModuleData}
                        renderOptions={({ setShowModal, setExcel }) =>
                            getOptions({ setShowModal, setExcel, t, setExportModuleDataOption })}
                        exportModuleDataOption={exportModuleDataOption}
                    />
                }

                {permissionButtons(TAB_PERMISSION_FOODIE(subView, selectedOption, bodyForExport?.cafeteriaId, subViewChild).EXPORT) &&
                    (search ? (
                        <ExportDataBtn
                            id='btn_fm_export'
                            moduleId={moduleId}
                            body={criteria}
                            search={search}
                            option={option}
                            callApi={subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST ?
                                (isExcel) => isExcel  ? handleDownloadExcelAttendance(): handleDownloadPDFAttendance()
                                : null
                            }
                            showHeadersModal={false}
                        />
                    ) : (
                        <ExportDataBtn
                            id='btn_fm_export'
                            moduleId={moduleId}
                            body={bodyForExport}
                            option={option}
                            search={search}
                            searchElement={searchElement}
                            callApi={subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST ?
                                (isExcel) => isExcel  ? handleDownloadExcelAttendance(): handleDownloadPDFAttendance()
                                : null
                            }
                            showHeadersModal={false}
                        />
                    ))}
                {TAB_PERMISSION_FOODIE(subView, selectedOption, bodyForExport?.cafeteriaId, subViewChild).ADVANCE_SEARCH?.[activeStep] && (
                    <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
                )}
                {permissionButtons(TAB_PERMISSION_FOODIE(subView, selectedOption, bodyForExport?.cafeteriaId, subViewChild).CREATE) &&
                    <ButtonAction
                        id='btn_fm_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            handleCreateDelete(ACTION_MODEL.CREATE);
                        }}
                    />
                }

                {permissionButtons(TAB_PERMISSION_FOODIE(subView, selectedOption, bodyForExport?.cafeteriaId, subViewChild).UPDATE) &&
                    <ButtonAction
                        id='btn_fm_update'
                        name='update'
                        className='btn-icon-edit'
                        Icon={EditIcon}
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                }

                {permissionButtons(TAB_PERMISSION_FOODIE(subView, selectedOption, bodyForExport?.cafeteriaId, subViewChild).DELETE) && (
                    <ButtonAction
                        id='btn_fm_delete'
                        name='delete'
                        className='btn-icon-delete'
                        Icon={TrashOutlineIcon}
                        disabled={paramsContext?.disabledBtnDelete}
                        onClick={() => {
                            handleCreateDelete(ACTION_MODEL.DELETE);
                        }}
                    />
                )}
            </HeadTittle>

            <StepperTabs
                id={null}
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_FOODIE.SCHEDULES.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.SCHEDULES.INDEX && (
                        <Schedule
                            subView={subView}
                            setSubView={setSubView}
                            modified={modified}
                            setModified={setModified}
                            option={option}
                            setOption={setOption}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_FOODIE.CAFETERIAS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.CAFETERIAS.INDEX && (
                        <Cafeterias
                            bodyForExport={bodyForExport}
                            setBodyForExport={setBodyForExport}
                            modified={modified}
                            setModified={setModified}
                            option={option}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_FOODIE.MENUS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.MENUS.INDEX &&
                        <Menu
                            subView={subView}
                            setSubView={setSubView}
                            setBodyForExport={setBodyForExport}
                            search={search}
                            setSearch={setSearch}
                            modified={modified}
                            setModified={setModified}
                            setSearchElement={setSearchElement}
                            searchElement={searchElement}
                            option={option}
                            setOption={setOption}
                            setModuleId={setModuleId}
                        />
                    }
                </StepTab>

                <StepTab index={TABS_FOODIE.DISHES.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.DISHES.INDEX && (
                        <Dishes
                            setBodyForExport={setBodyForExport}
                            modified={modified}
                            setModified={setModified}
                            option={option}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_FOODIE.INGREDIENTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.INGREDIENTS.INDEX && (
                        <Ingredients
                            setBodyForExport={setBodyForExport}
                            setCriteria={setCriteria}
                            view={view}
                            setView={setView}
                            modified={modified}
                            setModified={setModified}
                            option={option}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_FOODIE.REQUESTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_FOODIE.REQUESTS.INDEX && (
                        <Request
                            setBodyForExport={setBodyForExport}
                            subView={subView}
                            setSubView={setSubView}
                            modified={modified}
                            setModified={setModified}

                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            option={option}
                            setOption={setOption}
                            setSearch={setSearch}
                            simpleSearch={simpleSearch}
                            setSimpleSearch={setSimpleSearch}
                            setModuleId={setModuleId}

                            setCriteria={setCriteria}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_FOODIE.MANAGE.INDEX} activeStep={activeStep} classes={"position-relative"} normalHeight={true}>
                    {activeStep === TABS_FOODIE.MANAGE.INDEX &&
                    <Manage
                        subView={subView}
                        setSubView={setSubView}
                        subViewChild={subViewChild}
                        setSubViewChild={setSubViewChild}
                        criteria={criteria}
                        setCriteria={setCriteria}
                        setBodyForExport={setBodyForExport}
                        finalArray={finalArray}
                        setFinalArray={setFinalArray}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                        render={render}
                        setRender={setRender}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        setModuleId={setModuleId}
                        option={option}
                        setOption={setOption}
                        modified={modified}
                        setModified={setModified}
                        DEV={DEV}
                        permission={permission}
                        search={search}
                    />
                    }
                </StepTab>
            </StepperTabs>

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFinalArray(originalArray);
                        setFilterDialogShow(false);
                        setSearchElement('');// Clear search input after filtering
                        setSelectedOption(ATTENDANCE_MODES.daily);
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    search={search}
                    setSearch={setSearch}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    setFinalArray={setFinalArray} // Used to reset filters
                    searchElement={searchElement} // Track input changes
                />
            }
        </>
    );
};

export default FoodieMain;
